import { FeatureFlags } from '@/interfaces/feature-flags';

export const GET_GLOBAL_FEATURE_FLAGS = 'featureFlags/GET_GLOBAL_FEATURE_FLAGS' as const;
export const SET_FEATURE_FLAGS = 'featureFlags/SET_FEATURE_FLAGS' as const;

export const getGlobalFeatureFlags = () => ({ type: GET_GLOBAL_FEATURE_FLAGS });

export const setFeatureFlags = (payload: FeatureFlags) => ({ type: SET_FEATURE_FLAGS, payload });
